
import {defineComponent, PropType, ref} from "vue";
import {ITopic} from "@/interfaces/evidence-map";
import SrListTile from "@/components/SrListTile.vue";
import ProtListTile from "@/components/ProtListTile.vue";
import RctListTile from "@/components/RctListTile.vue";

export default defineComponent({
  name: "TopicViewer",
  components: {SrListTile, RctListTile, ProtListTile},
  props: {
    topic: {
      type: Object as PropType<ITopic>
    }
  },
  setup(props) {
    const tabs = [
      {label: `${props.topic.rct.length} RCT`, value: 0},
      {label: `${props.topic.sr.length} SR`, value: 1},
      {label: `${props.topic.prot.length} Ongoing`, value: 2},
    ]
    const activeTab = ref(0);
    return {
      tabs,
      activeTab,
    }

  }
})
